import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import TranslationProvider, { getTranslation } from '../../providers/TranslationProvider';

import Icon from '../Icon/Icon';
import RGAIcon from '../../svg/icons/ic_rga-standard_20x20.svg';

import './Rga.scss';

const RGA_VARIANT = {
  default: 'default',
  bold: 'bold',
  small: 'small',
  'x-small': 'x-small',
  heading: 'heading',
};
const iconLabel = getTranslation({ translationKey: 'gda_icon', fallback: 'Global Dining Access icon' });

const Rga = ({ variant }) => {
  const rgaCopy = getTranslation({ translationKey: 'rga', fallback: 'Global Dining Access' });
  const isHeading = variant === 'heading';
  return (
    <div className={cx('Rga', { [`Rga__${variant}`]: RGA_VARIANT[variant] })}>
      <Icon component={RGAIcon} name="rga" role="img" ariaLabel={iconLabel} />
      {isHeading
        ? <h3 className="Rga Rga__heading--copy">{rgaCopy}</h3>
        : <span>{rgaCopy}</span>}
    </div>
  );
};

const RgaMember = ({ variant }) => (
  <div className={cx('Rga-Member', { [`Rga-Member__${variant}`]: RGA_VARIANT[variant] })}>
    <Icon component={RGAIcon} name="rga" role="img" ariaLabel={iconLabel} />
    <TranslationProvider translationKey="rga_member">
      <span>Global Dining Access Member</span>
    </TranslationProvider>
  </div>
);

Rga.displayName = 'Rga';
Rga.propTypes = {
  variant: PropTypes.oneOf(Object.values(RGA_VARIANT)),
};
Rga.defaultProps = {
  variant: 'default',
};

RgaMember.displayName = 'RgaMember';
RgaMember.propTypes = {
  variant: PropTypes.oneOf(Object.values(RGA_VARIANT)),
};
RgaMember.defaultProps = {
  variant: 'default',
};

export default Rga;
export { RgaMember, RGA_VARIANT };
